export function addCurrent(breakreasons) {
  return {
    type: "ADD_CURRENT",
    breakreasons,
  };
}
